/**
 * Standard Spring-Konfigurationen für Motion Animationen
 * Konsistent mit CSS Custom Properties in globals.css
 */

export const springConfig = {
  default: {
    stiffness: 220,
    damping: 34,
    mass: 0.2,
  },
  smooth: {
    stiffness: 260,
    damping: 36,
    mass: 0.22,
  },
} as const;

export type SpringConfigType = keyof typeof springConfig;
